/* eslint-disable prettier/prettier */
export const section = [
  'flex w-full flex-col items-center',
  'max-w-[23.438rem] gap-[3.25rem] pt-[4rem] pb-5',
  'md:gap-[4rem] md:pt-[7.5rem] md:pb-[5rem] md:max-w-[90rem]'
].join(' ');

export const header = [
  'flex flex-col items-center',
  'gap-2',
  'md:gap-3'
].join(' ');

export const cardsWrap = [
  'w-full relative flex flex-col justify-center',
  'gap-2.5 px-[1rem] w-[21.438rem] min-h-[37.5rem]',
  'md:min-h-0 md:flex-row md:gap-3 md:px-0 md:w-full md:max-w-[70rem]'
].join(' ');

export const card = [
  'left-0 right-0 w-full overflow-hidden rounded-[1.25rem]',
  'absolute w-[21.438rem] h-[18.75rem]',
  'md:relative md:top-0 md:h-[19.9rem] md:w-[22.815rem]'
].join(' ');

export const cardImage = 'object-contain';
